import { z } from 'zod'

export enum OnBoardingSteps {
    ACCOUNT = 'ACCOUNT',
    EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
    PROFILE = 'PROFILE',
    RECOVERY_LOGIN = 'RECOVERY_LOGIN',
    SIGN_UP = 'SIGN_UP',
    TOTP_VERIFICATION = 'TOTP_VERIFICATION',
}

export enum EnumFlowActionType {
    NEXT_STEP = 'NEXT_STEP',
    PREVIOUS_STEP = 'PREVIOUS_STEP',
}


export enum EnumAccountType {
    EMPLOYER = 'EMPLOYER',
    LAWYER = 'LAWYER',
    NONE = '',
    SCHOOL_ADMIN = 'SCHOOL_ADMIN',
    STUDENT = 'STUDENT',
    SUPER_ADMIN = 'SUPER_ADMIN',
}



// Define the initial state type
type StudentRegisterState = {
    accountType: EnumAccountType.STUDENT;
    company?: never;
    student: {
        currentVisaStatus: string,
        degreeProgram: string;
        email: string;
        expectedGraduation: string;
        firstName: string;
        lastName: string;
        phoneNumber: string;
        termsAndConditions: boolean;
    };
};

type CompanyRegisterState = {
accountType: EnumAccountType.EMPLOYER;
company: {
    email: string;
    industry: string;
    name: string;
    sponsorship: string;
    website: string;
};
student?: never;
};

type RegisterState = {
    accountType: EnumAccountType;
    institution?: {
        industry: string;
        name: string;
        sponsorship: string;
        website: string;
    };
    user: {
        currentVisaStatus?: string;
        degreeProgram?: string;
        email: string;
        expectedGraduation?: string;
        firstName: string;
        institutionId?: string;
        lastName: string;
        major?: string;
        phoneNumber?: string;
    };
}

  export type TRegisterState = RegisterState & {
    progress: number;
    step: OnBoardingSteps;
  };


  ///DEFINE THE ACTION TYPE
  export type TAction<T> = {
    payload: T
    type: EnumFlowActionType
  }

  export type TStepPayload = {
    step: OnBoardingSteps
  }

/**
 * The old schema hard-required a `.edu`/`@purposeconnect.us`/`@bantuinvestments.com`
 * email domain for students/school-admins - that job now belongs to the institution
 * picker (`user.institutionId`), which is a real backend-verified ID rather than a
 * guessed domain pattern. Most fields stay optional here since each on-boarding step
 * validates only what it collects via its own `onContinue` handler, not the whole
 * shared form at once.
 */
export const registrationSchema = z.object({
  accountType: z.nativeEnum(EnumAccountType).optional(),
  institution: z
    .object({
      industry: z.string().min(1, 'Industry is required.').optional(),
      name: z.string().min(1, 'Institution name is required.').optional(),
      sponsorship: z.string().min(1, 'Sponsorship is required.').optional(),
      website: z.string().url('Invalid URL').optional().or(z.literal('')),
    })
    .optional(),
  user: z.object({
    currentVisaStatus: z.string().optional(),
    degreeProgram: z.string().optional(),
    email: z.string().min(1, 'Email is required.').email('Invalid email address.'),
    expectedGraduation: z.string().optional(),
    firstName: z.string().optional(),
    institutionId: z.string().optional(),
    lastName: z.string().optional(),
    major: z.string().optional(),
    phoneNumber: z.string().optional(),
  }),
})

export type RegistrationSchema = z.infer<typeof registrationSchema>
